(function () {
  angular.module('MktzapApp.Controllers')
    .controller('WebChatController', webchat);

  webchat.$inject = ['$timeout', '$window', '$scope', '$http', '$stateParams', '$location', 'FoundationApi', 'CompanyService', 'Upload', 'ChatService', '$rootScope', '$state', 'NotificationService'];

  function webchat ($timeout, $window, $scope, $http, $stateParams, $location, FoundationApi, CompanyService, Upload, ChatService, $rootScope, $state, NotificationService) {
    var vm = this;

    vm.company = {};
    vm.metadata = {};
    vm.baseUrl = baseUrl;
    vm.company.webchats = [];

    CompanyService.findForChannel({
      type: 'webchat'
    }, function (data) {
      vm.company = data;
      vm.emails = vm.company.emails;
      if (vm.company.metadata !== undefined && vm.company.metadata !== null) {
        for (var i in vm.company.metadata) {
          if (typeof vm.company.metadata[i]['value'] === 'string') {
            vm.metadata[vm.company.metadata[i]['key']] = JSON.parse(vm.company.metadata[i]['value']);
          } else {
            vm.metadata[vm.company.metadata[i]['key']] = vm.company.metadata[i]['value'];
          }
        }
      }
    });

    // Edit
    if ($stateParams.id) {
      ChatService.findOne({ id: $stateParams.id })
        .$promise
        .then(function (data) {
          vm.webchats = data;
          for (var i = 0; i < vm.webchats.length; i++) {
            var webchat = vm.webchats[i];
          }
          vm.webchat = webchat;
        })
        .catch(function (data) {
          // errorHandler(data,"Erro ao carregar Dados para Edição.");
        })
    }

    vm.edit = function (id) {
      $state.go('main.create-webchat', { id: id });
    }

    vm.new = function () {
      $state.go('main.create-webchat');
    }

    vm.comeBack = function () {
      $state.go('main.web-chat');
    }

    vm.goToTriggers = function (id) {
      $state.go('main.triggers', { type: 'web', id: id });
    }

    vm.confirmDelete = function (webchat, index) {
      vm.index = index;
      vm.webchat = webchat;
      FoundationApi.publish('webChatConfirmDeleteModal', 'open');
    }

    vm.delete = function (webchat, index) {
      FoundationApi.publish('webChatConfirmDeleteModal', 'close');
      ChatService.delete({ id: webchat.id })
        .$promise
        .then(function (data) {
          vm.company.webchats.splice(index, 1);
          NotificationService.successHandler(data, $scope.labels.theWchat + webchat.custom_data.nome + $scope.labels.removed);
        })
        .catch(function (data) {
          NotificationService.errorHandler(data, $scope.labels.errorLoadData);
        })
    }

    vm.addChatField = function (webchat) {
      vm.webchat = webchat;
      if (vm.webchat.custom_data == undefined) {
        vm.webchat.custom_data = {};
      }
      if (vm.webchat.custom_data.fields == undefined) {
        vm.webchat.custom_data.fields = [];
      }
      vm.webchat.custom_data.fields.push({});
    }
    vm.removeChatField = function (webchat, index) {
      vm.webchat.custom_data.fields.splice(index, 1);
    }

    vm.updateOptions = function (field) {
      field.options = [];
    }
    vm.addOption = function (field) {
      field.options.push('');
    }
    vm.removeOption = function (field, index) {
      field.options.splice(index, 1);
    }

    vm.psSaveChat = function (webchat, create) {
      var promiseChat;
      if (create) {
        promiseChat = ChatService
          .create({}, webchat)
          .$promise
      } else {
        promiseChat = ChatService
          .update(
            { id: webchat.id },
            webchat)
          .$promise
      }
      return promiseChat;
    }

    vm.saveChat = function (file, webchat) {
      var promiseChat, message;
      if (!webchat) {
        NotificationService.errorHandler(webchat, $scope.labels.requiredFields);
        return false;
      }
      if (!webchat.hasOwnProperty('id')) {
        webchat.company_id = $rootScope.user_data.company_id;
        promiseChat = vm.psSaveChat(webchat, true);
        message = $scope.labels.created;
      } else {
        promiseChat = vm.psSaveChat(webchat, false);
        message = $scope.labels.updated;
      }
      promiseChat
        .then(function (data) {
          if (data.success == false) {
            NotificationService.errorHandler(data, data.message);
            return false;
          }
          vm.company.webchats.push(data);
          if (file) {
            file.upload = Upload.upload({
              url: apiUrl + '/webchat-upload',
              fields: { id: data.id },
              file: file[0]
            });
            file.upload
              .then(function (response) {
                if (response.data.success == false) {
                  NotificationService.warningHandler(response, response.data.message);
                  return false;
                } else if (response.data.success == true) {
                  NotificationService.successHandler(response, response.data.message);
                  if ($stateParams.id) {
                    $state.go('main.create-webchat', { id: $stateParams.id });
                  } else {
                    $state.go('main.create-webchat', { id: response.config.fields.id });
                  }
                }
                $timeout(function () {
                  vm.webchat.logo_path = response.data.url;
                });
              })
              .catch(function (error) {
                if (error.status > 0) { NotificationService.warningHandler(error, $scope.labels.maxSize); }
              });
          }
          if (!file) {
            NotificationService.successHandler(data, $scope.labels.theData + message + $scope.labels.success);
            if ($stateParams.id) {
              $state.go('main.create-webchat', { id: $stateParams.id });
            } else {
              $state.go('main.create-webchat', { id: data.id });
            }
          }
        })
        .catch(function (error) {
          NotificationService.errorHandler(error, $scope.labels.errorProcessReq);
        });
    }

    vm.uploadFiles = function (file, webchat) {
      if (file) {
        if (file.length) {
          vm.saveChat(file, webchat);
        }
      }
    };

    vm.deleteImage = function (webchat) {
      ChatService
        .deleteImage({ id: webchat.id })
        .$promise
        .then(function (data) {
          vm.webchat.logo_path = '';
          NotificationService.successHandler(data, $scope.labels.sucRemoveImg);
        })
        .catch(function (data) {
          NotificationService.errorHandler(data, $scope.labels.errorRemoveImg);
        })
    }

    vm.copy = function () {
      var element = angular.element('#copy');
      element.select();
      document.execCommand('copy');
    }
  }
})();
